import React, { useMemo, memo, type FC } from 'react'
import { Flex } from 'antd'

import { type IOktaUser } from '../../../constants/types/generatedTypesAliases'
import { UserStatus } from '../../../constants/types/common'
import { BooleanLabelIcon } from '../../shared'

interface IUserDetailsOverviewProps {
  selectedUser: IOktaUser
}

export const UserDetailsOverview: FC<IUserDetailsOverviewProps> = memo(({ selectedUser }) => {
  const detailsData = useMemo(() => {
    if (!selectedUser) return {}
    const { id, status, firstName, lastName, timeZone, manager, displayName, secondEmail } = selectedUser

    return {
      'First Name': firstName,
      'Last Name': lastName,
      'Preferred Username': `${firstName} ${lastName}`,
      'Timezone': timeZone,
      'User ID': id,
      'Manager': manager,
      'Display Name': displayName,
      'Second Email': secondEmail,
      'Active:': status === UserStatus.ACTIVE
    }
  }, [selectedUser])

  return Object.entries(detailsData).map(entry => {
    return (
      <div key={entry[0]}>
        <Flex className='overview__row'>
          <Flex className='overview__label'><b>{entry[0]}</b></Flex>
          <Flex>
            {typeof entry[1] === 'boolean' ? <BooleanLabelIcon value={entry[1]} /> : entry[1]}
          </Flex>
        </Flex>
        <hr className='overview__delimiter' />
      </div>
    )
  })
})
